import { __assign, __rest } from "tslib";
import React from 'react';
import s from './fluid-container.scss';
export var FluidContainer = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, dataHook = _a.dataHook, extraProps = __rest(_a, ["children", "className", "dataHook"]);
    return (React.createElement("div", __assign({}, extraProps, { "data-hook": dataHook, className: s.fluidContainer + " " + className }), children));
};
//# sourceMappingURL=fluid-container.js.map